import axios from 'axios';
import * as _ from 'lodash';
import * as Qs from 'qs';

import { IProjectsParams, IUrlParams } from 'src/models';

export default {
    // 获取URL参数
    getUrlParamsSync(urlStr: string): IUrlParams {
        let url = '';
        if (typeof urlStr === 'undefined') {
            url = decodeURI(location.search); // 获取url中'?'符后的字符串
        } else {
            url = '?' + urlStr.split('?')[1];
        }
        const params: IUrlParams = {};
        if (-1 !== url.indexOf('?')) {
            const paramString = url.substr(1); // 删除'?'
            const paramStrings = paramString.split('&');
            _.forEach(paramStrings, (item) => {
                const keyValue = item.split('=');
                if (params[keyValue[0]]) {
                    params[keyValue[0]].push(decodeURI(keyValue[1]));
                } else {
                    params[keyValue[0]] = [decodeURI(keyValue[1])];
                }
            });
        }
        return params;
    },

    // 更新页面url，并存入浏览器访问历史
    // - route: 页面路由（"域名:端口" 和 "?" 之间的部分）
    // - params: 路由参数
    updateUrlSync(route: string, params: IUrlParams): void {
        // 将数组参数转换成”&“拼接的字符串（例如：ids=[1,2] 转换成 ids=1&ids=2）
        const paramsStr = Qs.stringify(params, {
            indices: false,
        });
        const url = paramsStr ? `${route}?${paramsStr}` : route;
        history.pushState({ url }, '', url);
    },

    // 获取url上的id
    // 例如：system/configs/10，获取id=10
    getUrlIdSync(): string {
        return location.pathname.split('/').pop();
    },

    // 批量生成唯一id
    getNewIds(count = 1): Promise<string[]> {
        return axios.get<any>(`/api/audits/newids`, { params: { count } }).then((res) => {
            return res.data;
        });
    },

    // 生成唯一id
    getNewId(): Promise<string> {
        return this.getNewIds(1).then((ids) => {
            return ids[0];
        });
    },

    // 移除空属性（undefined、null、 '' 等，不包括0）
    omitEmptyParams(params: { [key: string]: any }): { [key: string]: any } {
        return _.omitBy(params, (value) => {
            return !(value || 0 === value);
        });
    },

    // urlParams -> ProjectsParams
    urlParams2ProjectsParamsSync(urlParams: IUrlParams): IProjectsParams {
        const projectsParams: IProjectsParams = {
            include_schedule:
                urlParams.include_schedule && 'true' === urlParams.include_schedule[0],
            role: urlParams.role && urlParams.role[0],
            status: urlParams.status,
            type: urlParams.type,
            level: urlParams.level,
            group: urlParams.group,
            light: urlParams.light,
            category: urlParams.category,
            organization: urlParams.organization && urlParams.organization[0],
            create_organization: urlParams.create_organization && urlParams.create_organization[0],
            from_date: urlParams.from_date && urlParams.from_date[0],
            to_date: urlParams.to_date && urlParams.to_date[0],
            q: urlParams.q && urlParams.q[0],
            current_user_id: urlParams.current_user_id && urlParams.current_user_id[0],
            page: urlParams.page && +urlParams.page[0],
            limit: urlParams.limit && +urlParams.limit[0],
            order: urlParams.order && urlParams.order[0],

            tree: urlParams.tree, // 祖先节点ids，用于展开到最后访问的项目

            search_mode: urlParams.search_mode && +urlParams.search_mode[0], // 搜索模式：默认/精准模式
        };
        return this.omitEmptyParams(projectsParams);
    },

    // 版本号
    getVersion(): Promise<string> {
        const version =
            document.querySelector('meta[name="version"]')?.getAttribute('content') ?? 'latest';
        return Promise.resolve(version);
    },

    // 将文本中的链接转化为 Html，方便在 pre 中可直接点击跳转
    convertLinksToHtml(text: string): string {
        const urlPattern =
            /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
        return text.replace(urlPattern, '<a class="btn-link" href="$1" target="_blank">$1</a>');
    },
};
